import {ChangeEvent, useEffect, useState} from 'react';
import {Option} from '../../../../../types';

export type UseWidgetSelectedGames = [Option[], (event: ChangeEvent, options: Option[]) => void];

const useWidgetSelectedGames = (initialSelectedGames: Option[]): UseWidgetSelectedGames => {
    const [selectedGames, setSelectedGames] = useState(initialSelectedGames);

    const handleSelectGames = (_event, options: Option[]) => {
        setSelectedGames(options);
    };

    useEffect(() => {
        if (selectedGames !== initialSelectedGames) {
            setSelectedGames(initialSelectedGames);
        }
    }, [initialSelectedGames, setSelectedGames]);

    return [selectedGames, handleSelectGames];
};

export default useWidgetSelectedGames;
